import React, { Component } from "react";

import { MDBModalBody, MDBModalHeader, MDBRow, MDBCol } from "mdbreact";

import PendingGatewayVLANDisableTable from "../../../components/NetworkMgmt/Support/Datatables/PendingGatewayVLANDisableTableMUI";
class EquipmentErrorLog extends Component {
    state = {
        pendingGatewayVLANDisable: this.props.pendingGatewayVLANDisable,
    };

    render() {
        return (
            // <div className="logList">
            <>
                <MDBModalHeader
                    toggle={this.props.togglelistPendingGatewayVLANDisable}
                >
                    <h4>Pending Gateway VLAN Disable</h4>
                </MDBModalHeader>
                <MDBModalBody>
                    <MDBRow>
                        <MDBCol col="12">
                                <PendingGatewayVLANDisableTable
                                    pendingGatewayVLANDisable={
                                        this.props.pendingGatewayVLANDisable
                                    }
                                />
                        </MDBCol>
                    </MDBRow>
                </MDBModalBody>
                </>
            // </div>
        );
    }
}

export default EquipmentErrorLog;
